import classNames from 'classnames/bind';

import { kgLogo } from '../../assets/icons/Icons';
import Styles from './LogoLoader.module.scss';

const cx = classNames.bind(Styles);

type Props = {
  disable?: boolean;
  inline?: boolean;
  hasNav?: boolean;
};

/* Logo Loader component */
const LogoLoader = ({ disable = false, inline = false, hasNav = false }: Props) => {
  return (
    <>
      {!disable ? (
        <div className={'col-12 ' + cx('loader', { 'loader--inline': inline }, { 'loader--hasnav': hasNav })}>
          {kgLogo}
        </div>
      ) : null}
    </>
  );
};

export default LogoLoader;
